import { Separator, VStack } from "@chakra-ui/react"
import { ReactNode } from "react"

type CardLinksProps = {
  children: ReactNode
}

// Renders a list of CardLinks separateed by Dividers that conditionally hide
// when the group is hovered over.
function CardLinks({ children }: CardLinksProps) {
  return (
    // NOTE: idea is to hide the Separator when an adjacent item is hovered,
    // but current solution targets parent hover, so all Dividers will hide when
    // parent is hovered. This seems to be OK, even fine, but will need to refactor if not.
    // This idea maybe moot if we don't round the CardLink borders.
    <VStack
      className="group"
      w="100%"
      gap={0}
      align="center"
      separator={
        <Separator
          w="full"
          // size="xs" // Why you no work and must use borderWidth props?
          borderBottomWidth={0}
          borderTopWidth="1px"
          _groupHover={{ visibility: "hidden" }}
          _groupFocusWithin={{ visibility: "hidden" }}
        />
      }
    >
      {children}
    </VStack>
  )
}

export default CardLinks
